export default __webpack_public_path__ + "static/media/key.bec37423.png";